export const POLICY_VERSION = '2026-08-24';
export const SUPPORT_EMAIL = 'livenow.enterprise@gmail.com';
export const APP_ORIGIN = 'https://livenow-app.com';
export const PENDING_CONSENT_KEY = 'livenow.pendingConsent';

export function buildConsentPayload() {
  return {
    accepted: true,
    policyVersion: POLICY_VERSION,
    acceptedAt: new Date().toISOString(),
  };
}

export function persistPendingConsent() {
  try {
    sessionStorage.setItem(PENDING_CONSENT_KEY, JSON.stringify(buildConsentPayload()));
  } catch {
    // ignore
  }
}

export function consumePendingConsent() {
  try {
    const raw = sessionStorage.getItem(PENDING_CONSENT_KEY);
    sessionStorage.removeItem(PENDING_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.accepted === true && parsed?.policyVersion) return parsed;
  } catch {
    // ignore
  }
  return null;
}
